
import react.FC
import react.create
import react.dom.client.createRoot
import react.router.dom.RouterProvider
import ui.router.MyRouter
import ui.themePlusContext.LoadDataContextProvider
import ui.themePlusContext.MyContextModule
import ui.themePlusContext.ToastProvider
import web.dom.document
import web.html.HTML.div


fun main()
{
    val container = document.createElement(div).also { document.body.appendChild(it) }
    createRoot(container).render(App.create())
}

val App = FC{
    MyContextModule{
        ToastProvider{
            LoadDataContextProvider{
                RouterProvider{
                    router = MyRouter
                }
            }
        }
    }
}